import React from 'react'
import BrandItemContainer from './BrandItemContainer'
import { brandShape } from '../../shapes'

const BrandItem = ({ brand }) => (
  <BrandItemContainer brand={brand} data-test="component-brand-item" />
)

BrandItem.propTypes = {
  brand: brandShape.isRequired
}

export default BrandItem
